import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import MainCard from '../../../components/MainCard';
import CenteredSpinner from '../../../components/CenteredSpinner';
import DashboardServices from '../../../services/DashboardServices';
import localStorageService from '../../../services/localStorageService';
import MainCardTitle from './MainCardTitle';
import WidgetCard from './WidgetCard';

const Badge = ({ children }) => (
    <Box sx={{ mr: 2, bgcolor: '#e6f0ff', color: '#1e3a8a', px: 1.2, py: 0.6, borderRadius: 1.5, minWidth: 36, textAlign: 'center' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{children}</Typography>
    </Box>
);

const Item = ({ count, name }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', border: '1px solid rgba(59,130,246,0.3)', borderRadius: 1.5, px: 1.5, py: 1, mb: 1 }}>
        <Badge>{count}</Badge>
        <Typography sx={{ color: 'text.primary' }}>{name}</Typography>
    </Box>
);

const OfficerStats = () => {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            try {
                // decide params (include organization_id when user has specific roles)
                const storedUser = localStorageService?.getItem?.('user') ?? null;
                const roles = (storedUser?.roles) || (storedUser?.role) || storedUser?.rolesArray || [];
                const normalizedRoles = Array.isArray(roles) ? roles.map(r => String(r).toLowerCase()) : [];
                const targetRoles = ['organization admin', 'case officer', 'case manager', 'organization head', 'director cid', 'director ncpa', 'deputy director','oic','department head','team leader first respondent','team leader first respondent','call center officer mowca','call center officer mowca', 'counselling officer', 'legal officer'];
                const hasTargetRole = normalizedRoles.some(r => targetRoles.includes(r));

                const params = { limit: 20, active_only: true };
                if (hasTargetRole) {
                    const orgId = storedUser?.employee?.organization_id ?? storedUser?.organization_id ?? storedUser?.org?.id ?? null;
                    if (orgId) params.organization_id = orgId;
                }

                const targetEmployee_id_Roles = ['case officer', 'first respondent', 'counselling officer', 'legal officer'];
                const needToPassUserId = normalizedRoles.some(r => targetEmployee_id_Roles.includes(r));
                if (needToPassUserId) {
                    const employeeId = storedUser?.employee?.id ?? storedUser?.employee_id ?? null;
                    if (employeeId) params.employee_id = employeeId;
                }


                const res = await DashboardServices.getDashboardOfficerStats(params);
                const payload = res?.data ?? res;
                // Expected response shape: { msg: '', data: [ { officer_id, officer_name, case_count }, ... ] }
                const dataArray = payload?.data ?? payload?.view?.data ?? payload ?? [];
                if (mounted) setItems(Array.isArray(dataArray) ? dataArray : (dataArray.items || []));
            } catch (err) {
                console.error('Failed to load officer stats', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        load();
        return () => { mounted = false; };
    }, []);

    //if (loading) return <MainCard><CenteredSpinner /></MainCard>;

    return (
        <WidgetCard>
            <MainCardTitle>Officers with handling case</MainCardTitle>

            <Grid container spacing={1}>
                {items.map((it) => (
                    <Grid key={it.officer_id ?? it.id} item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <Item count={it.case_count ?? it.caseCount ?? 0} name={it.officer_name ?? it.officerName ?? it.name ?? '—'} />
                    </Grid>
                ))}
            </Grid>
        </WidgetCard>
    );
};

export default OfficerStats;
